// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ab01d14d","977":"56961f36"}[chunkId] + ".chunk.js";
};